<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>理赔录入
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="
                    scope.column.property === 'reciClaimAmount' ||
                    scope.column.property === 'verfyClaimAmount' ||
                    scope.column.property === 'ourLossAmount' ||
                    scope.column.property === 'otherLossAmout'
                  "
                >
                  {{ scope.row[scope.column.property] / 100 }}
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  claimsList,
} from 'api/system';
import TableSetting from 'components/tableSetting/tableSetting';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'plateNumber', label: '车牌号', fixed: true },
          { prop: 'licenceTypeName', label: '牌照类型' },
          { prop: 'reciClaimAmount', label: '收理赔金额' },
          { prop: 'verfyClaimAmount', label: '核赔金额' },
          { prop: 'orgIdName', label: '归属部门' },
          { prop: 'ourLossAmount', label: '我方损失金额' },
          { prop: 'otherLossAmout', label: '对方损失金额' },
          { prop: 'accidentTime', label: '事故时间' },
          { prop: 'accidentAddress', label: '事故地点' },
          { prop: 'opName', label: '记录人' },
          { prop: 'createDate', label: '记录时间' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: claimsList,
    toEdit () {
      this.jump({
        label: '登记费用',
        url: '/manage/system/income/claims/edit',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
